import React from "react";
import PropTypes from "prop-types";
import AudioCollectionItem from "../../atoms/audio-collection-item";
import styles from "./styles.m.css";

export class AudioPage extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div>
        <AudioCollectionItem collection={data.collection} />
        <div className={styles["benefits-wrapper-main"]}>
          <div className="container">
            <div className={styles["benefits-wrapper"]}>
              <h2>App-ன் பிற சிறப்பம்சங்கள்</h2>
              <ul className={styles["benefits-list"]}>
                <li>
                  <img
                    src="https://media.vikatan.com/vikatan/2023-04/a8fe2e42-75b8-490d-9e51-4481e0592b0a/feature_one.png"
                    alt=""
                  />
                  <span>
                    சினிமா, அரசியல், விவசாயம், ஆன்மிகம், முதலீடு, வாகனம் மற்றும் பெண்கள் முன்னேற்றம் பற்றி தெரிந்துகொள்ள
                    7 விகடன் இதழ்கள்.
                  </span>
                </li>
                <li>
                  <img
                    src="https://media.vikatan.com/vikatan/2023-04/1f99aae8-9405-4d3b-a393-f6eafa36404f/feature_two.png"
                    alt=""
                  />
                  <span>
                    கி.ராஜநாராயணன், அசோகமித்திரன், சுஜாதா போன்ற எழுத்தாளுமைகள் எழுதிய 1000-க்கு மேற்பட்ட சிறுகதைகள்
                  </span>
                </li>
                <li>
                  <img
                    src="https://media.vikatan.com/vikatan/2023-04/a867bbfb-77a7-4c76-8237-1c3d7f68f4ee/feature_three.png"
                    alt=""
                  />
                  <span>
                    வேள்பாரி, மூன்றாம் உலகப்போர், இயக்குநர் வெற்றிமாறனின் மைல்ஸ் டு கோ போன்ற 500-க்கு மேற்பட்ட
                    தொடர்கள்...
                  </span>
                </li>
                <li>
                  <img
                    src="https://media.vikatan.com/vikatan/2023-04/5ed7a4ef-e45f-424d-bf05-4297026b242c/feature_four.png"
                    alt=""
                  />
                  <span>விகடனின் கிளாஸிக் படைப்புகளைப் படிக்க உதவும் VIP Access</span>
                </li>
                <li>
                  <img
                    src="https://media.vikatan.com/vikatan/2023-04/781c72cc-d1b6-4e66-a5aa-0bfe571b7d50/feature_five.png"
                    alt=""
                  />
                  <span>கூகுளே உங்களுக்காக செய்திகளை வாசிக்கும் Text to Speech வசதி</span>
                </li>
                <li>
                  <img
                    src="https://media.vikatan.com/vikatan/2023-04/6afec113-f0db-4b6d-9878-1af027aa7349/feature_six.png"
                    alt=""
                  />
                  <span>விளம்பர இடையூறில்லா வாசிப்பனுபவம்</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={styles["audio-footer"]}>
          <div className="container">
            <h1>
              விகடன் App-ஐ டவுன்லோடு செய்து இப்போதே உங்கள் விருப்பமான ஆடியோ புத்தகங்களை கேட்டு மகிழ்ந்திடுங்கள். அதுவும்
              30 நாள்களுக்கு இலவசமாக!
            </h1>
            <div className={styles["audio-footer-icons"]}>
              <div>
                <a href="https://play.google.com/store/apps/details?id=com.vikatanapp&referrer=utm_source%3Dproduct_page%26utm_medium%3Dproduct_footer%26utm_campaign%3Daudio">
                  <img src="https://media.vikatan.com/vikatan/2024-03/8f8aa33c-864e-488a-9c4a-07cebc3e1c01/audio_google_play.png" />
                </a>
              </div>
              <div>
                <a href="https://apps.apple.com/in/app/vikatan/id452698974">
                  <img src="https://media.vikatan.com/vikatan/2024-03/016dbe9d-c314-4b11-a23b-288fa772ee36/audio_app_store.png" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AudioPage.propTypes = {
  pageType: PropTypes.string,
  data: PropTypes.shape()
};
